import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/$workspaceId/dashboards')({ component: Outlet });
